var _g, _defs;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";
import { forwardRef } from "react";

const SvgHubspotLogo = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.029 10.832V7.074a2.894 2.894 0 0 0 1.669-2.608V4.38a2.894 2.894 0 0 0-2.894-2.894h-.087a2.894 2.894 0 0 0-2.894 2.894v.086a2.894 2.894 0 0 0 1.669 2.608v3.758a8.195 8.195 0 0 0-3.897 1.716L7.29 4.52c.073-.265.112-.538.116-.812A3.26 3.26 0 1 0 4.14 6.962a3.225 3.225 0 0 0 1.606-.437l10.149 7.898a8.22 8.22 0 0 0 .126 9.26l-3.087 3.087c-.25-.08-.51-.122-.772-.126a2.678 2.678 0 1 0 2.68 2.68 2.645 2.645 0 0 0-.126-.771l3.054-3.055a8.234 8.234 0 1 0 6.259-14.666m-1.266 12.36a4.226 4.226 0 1 1 0-8.446 4.225 4.225 0 0 1 .004 8.444",
    fill: "#FF7A59"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h32v32H0z"
  })))));
};

const ForwardRef = /*#__PURE__*/forwardRef(SvgHubspotLogo);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/hubspot-logo.4da1cc613aacbfe8f0eb9eeaaffd225a.svg";